/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Client document status
 */
export type GetApprovedAgreementsResponseItemStatus = typeof GetApprovedAgreementsResponseItemStatus[keyof typeof GetApprovedAgreementsResponseItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApprovedAgreementsResponseItemStatus = {
  NEW: 'NEW',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
  REMOVED: 'REMOVED',
  PENDING: 'PENDING',
} as const;
